module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_8-81d7c33a170d2d86bd89d2790aef207a.png";